export const SETTINGS = {
  PERSONAL_DATA: 'personalData',
  ACTIVITY_FEED: 'activityFeed',
  BOOST: 'boost',
  BUZZ: 'buzz',
  CONTENT: 'content',
  CONNECTED_ACCOUNTS: 'connectedAccounts',
  EMAIL_NOTIFICATION: 'emailNotification',
  FILTER: 'filter',
  INVITES: 'invites',
  LEARN_MORE_ABOUT_PRIVACY_ON_GMANTRA: 'learnMoreAboutPrivacyOnGmantra',
  MESSAGE: 'message',
  MESSAGES: 'messages',
  PASSWORD: 'password',
  INCOMING_REBUZZ: 'incomingRebuzz',
  OUTGOING_REBUZZ: 'outgoingRebuzz',
  REBUZZ_STATISTICS: 'rebuzzStatistics',
  REBUZZER: 'rebuzzer',
  SECURITY: 'security',
  SESSION: 'session',
  PUBLISHER: 'publisher',
};
